// extracted by mini-css-extract-plugin
export default {"slider":"productDeatilsCarassoul_slider__kKlmL","sliderMain":"productDeatilsCarassoul_sliderMain__XzoLA"};